import { Link } from 'react-router-dom';
import { actionLinkClassName } from '@core/theme/actionTheme.util';
import usePortalAccess from '@/access/usePortalAccess';
import { usePortalPath } from '@/hooks/usePortalPath';
import CandidateAvatar from '@/modules/timesheets/components/CandidateAvatar';

interface TimesheetDrawerPartiesProps {
  userId: string;
  workerName: string;
  workerProfileImageUrl?: string | null;
  clientId: string;
  clientName: string;
  showClientName: boolean;
}

/**
 * Candidate on the left, client on the right, at the top of a timesheet
 * drawer. Both link to their profiles, which only the tenant portal has.
 */
const TimesheetDrawerParties = ({
  userId,
  workerName,
  workerProfileImageUrl,
  clientId,
  clientName,
  showClientName,
}: TimesheetDrawerPartiesProps) => {
  const { isTenantPortal } = usePortalAccess();
  const { path } = usePortalPath();
  const linkClassName = `truncate text-sm hover:underline ${actionLinkClassName}`;
  const textClassName = 'truncate text-sm text-gray-900';

  return (
    <div className="mt-3 flex items-center justify-between gap-4">
      <div className="flex min-w-0 items-center gap-2">
        <CandidateAvatar name={workerName} imageUrl={workerProfileImageUrl} />
        {isTenantPortal && userId ? (
          <Link to={path(`/workers/${userId}`)} className={linkClassName}>
            {workerName}
          </Link>
        ) : (
          <span className={textClassName}>{workerName}</span>
        )}
      </div>
      {showClientName &&
        (isTenantPortal && clientId ? (
          <Link to={path(`/clients/${clientId}`)} className={linkClassName}>
            {clientName}
          </Link>
        ) : (
          <span className={textClassName}>{clientName}</span>
        ))}
    </div>
  );
};

export default TimesheetDrawerParties;
